import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreatePrivateCoaching = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Private Coaching'
      fields={fields}
      apiPath='admin/private_coachings'
      successRedirectPath={resource => `/write-now/private_coachings/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreatePrivateCoaching
